import React from 'react';
import { Form, RadioGroup } from 'react-form';

import PopupV3, { PopupTypes } from '../../../components/Popup/PopupV3';
import { RadioButton } from '../../../components/Form';

import styles from './playerWildcardPopup.scss';

const PlayerWildcardPopup = props => {
    const {
        onCloseClick,
        onSubmit,
        defaultValues = { wildcardStateId: 1 },
        memberId,
        options,
        'data-testid': dataTestId,
    } = props;

    const onFormSubmit = ({ wildcardStateId }) => {
        onSubmit({ memberId, wildcardStateId });
    };

    return (
        <PopupV3
            className={`popup-md`}
            onCloseClick={onCloseClick}
            type={PopupTypes.INFO}
            isOpen={true}
            data-testid={dataTestId}
            message={(
                <div className={styles.playerWildcardPopup}>
                    <Form
                        onSubmit={onFormSubmit}
                        defaultValues={defaultValues}
                    >
                        {(formApi) => {
                            const { submitForm, values } = formApi;
                            const { wildcardStateId } = values;
                            return (
                                <form onSubmit={submitForm} className="mb0">
                                    <div className="mb16" data-testid={dataTestId && `${dataTestId}.prompt`}>
                                        Tag player as ...
                                    </div>
                                    <div className="row mb24">
                                        <div className={`col-12`}>
                                            <RadioGroup
                                                field="wildcardStateId"
                                            >
                                                {options.map(({ id, label }) => (
                                                    <RadioButton
                                                        key={`wildcardStateId-${id}`}
                                                        id={`wildcardStateId-${id}`}
                                                        label={label}
                                                        value={id}
                                                        data-testid={dataTestId && `${dataTestId}.option-${id}`}
                                                    />
                                                ))}
                                            </RadioGroup>
                                        </div>
                                    </div>
                                    <div className={styles.buttonsContainer}>
                                        <button
                                            type="button"
                                            className={`btn btn-default btn-small text-uppercase`}
                                            onClick={onCloseClick}
                                            data-testid={dataTestId && `${dataTestId}.cancel-btn`}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className={`btn btn-primary btn-small text-uppercase`}
                                            disabled={!wildcardStateId || wildcardStateId === defaultValues.wildcardStateId}
                                            data-testid={dataTestId && `${dataTestId}.submit-btn`}
                                        >
                                            Update
                                        </button>
                                    </div>
                                </form>
                            );
                        }}
                    </Form>
                </div>
            )}
            onCancelClick={onCloseClick}
            showCancelButton={false}
            showConfirmButton={false}
            noIcon
            customContent
        />
    );
};

PlayerWildcardPopup.propTypes = {

};

export default PlayerWildcardPopup;
